import { clearAuthData } from './auth';
import { toast } from 'react-toastify';

/**
 * Handle API errors and provide appropriate user feedback
 * @param {object} error - Error object from API call
 * @param {string} defaultMessage - Default error message
 */
export const handleApiError = (error, defaultMessage = 'An error occurred') => {
  if (error.response) {
    const status = error.response.status;
    const message = error.response.data?.message || error.response.data || defaultMessage;

    switch (status) {
      case 401:
        // Unauthorized - session expired
        clearAuthData();
        toast.error('Session expired. Please login again.');
        
        // Redirect to login if not already there
        const currentPath = window.location.pathname;
        if (!currentPath.includes('/agent') && !currentPath.includes('/login')) {
          setTimeout(() => {
            window.location.href = '/agent';
          }, 1000);
        }
        break;
        
      case 403:
        // Forbidden - insufficient permissions
        toast.error('You do not have permission to perform this action.');
        break;
        
     
        
      case 422:
        // Validation error
        toast.error(message || 'Please check your input and try again.');
        break;
        
      case 500:
        // Server error
        toast.error('Server error. Please try again later.');
        break;
        
      default:
        toast.error(message || defaultMessage);
    }
  } else if (error.request) {
    // Network error
    toast.error('Network error. Please check your connection.');
  } else {
    // Other error
    toast.error(defaultMessage);
  }
};

/**
 * Check if error is authentication related
 * @param {object} error - Error object
 * @returns {boolean} - True if authentication error
 */
export const isAuthError = (error) => {
  return error.response && error.response.status === 401;
};

/**
 * Check if error is network related
 * @param {object} error - Error object
 * @returns {boolean} - True if network error
 */
export const isNetworkError = (error) => {
  return !error.response && error.request;
};